import React, { useState } from "react";
import Reportstotal from "./Reportstotal";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { historyIcon } from "./svg";
import { HistoryModal } from "./Historymodal";
import api from "../api/api";
import ReactPaginate from "react-paginate";
import { deleteIcon, editIcon } from "../user/svg";
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import { useSelector } from "react-redux";
import DeleteConfirmModal from "./deleconformation";
import close from '../assets/Reports/close.svg'
import DeleteRequestModal from "./deleterequestmodal";
import { getPracticeId } from "../config/practice";
const Reporttable = ({
  data,
  loading,
  fetchMethdata,
   isdeletedRecords,
    setIsRequested,
     isRequested,
  handledelete,
  setpaymentModal,
   setSelectedCard,
  totalData,
  handleCheckLocaClick,
  handleCheckMethodClick,
   checkLoca,
  checkMethod,
  onclearfilters,
  setloading,
  handlerequest,
  // OSA batch 6 (7825): no delete-request column, flag or delete icon, and
  // GRAND TOTAL alone under Daily Totals, as OSA's build had it.
  slim = false
}) => {
  const navigate = useNavigate();
        const practiseid = getPracticeId();
        const [deleteModal, setDeleteModal] = useState(false);
const [deleteItem, setDeleteItem] = useState(null);
  const [showHistory, setShowHistory] = useState(false);
  const [historydata,setHistoryData]=useState([])
  const [selectedpatient,setSelectedPatient]=useState({})
  const handlePatientClick = (item) => {
    navigate("/landing", { state: { item } }); // Pass the entire item as state
  };
    const paymentprev = useSelector(
            (state) => state.userPrivileges.Payment
          );
const [requestModal, setRequestModal] = useState(false);
const [requestItem, setRequestItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);
 
// const startIndex = currentPage * itemsPerPage;
const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;
 
// Slice data for current page
// const paginatedData = data.slice(startIndex, endIndex);
const paginatedData = data;
 
// ReactPaginate event
const handlePageClick = (e) => {
  setCurrentPage(e.selected);
};
 const confirmDelete = () => {
  handledelete(deleteItem);
  setDeleteModal(false);
};
const fetchpaymenthistory=async(x)=>{
setSelectedPatient(x)
  try {
    setloading(true)
    setHistoryData([])
    const response=await api.get(`/v1/${practiseid}/pcard/${x.patientid}/getPaymentDetails`)
    if(response.status==200){
      setHistoryData(response?.data||[])
      setShowHistory(true)
    }else{
      setHistoryData([])
    }
  } catch (error) {
    console.log(error)
  }finally{
    setloading(false)
  }
}
  return (
    <div className="gap-2">
      <div
        className="mt-2 shadow-md"
        style={{ borderRadius: "10px", overflow: "hidden" }}
      >
        <table className="min-w-full  text-center ">
          <thead className="sticky top-0 bg-[#50869A] text-white">
            <tr>
              <th className="py-2 px-2 border-b border-gray-200 text-[white] font-poppins text-[11px]">
                PATIENT NAME
              </th>
              <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]">
                PAID DATE
              </th>
              <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]">
                LOCATION
              </th>
              <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]">
                CO-PAY
              </th>
              <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]">
                SELF-PAY
              </th>
              <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]">
                PAYMENTS ON
                <br /> ACCOUNT
              </th>
              <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]">
                AMOUNT
              </th>
              <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]">
                PAYMENT <br /> METHOD
              </th>
              {!slim && <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]"> 
                Delete Request Reason
              </th>}
              {isdeletedRecords?   <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]">
                Deleted By
              </th>:<></>}
                 {(!slim && isRequested && !isdeletedRecords)?   <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]">
             Request Reason
              </th>:<></>}
                    {(!slim && isRequested && !isdeletedRecords)?  <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]">
             Request By
              </th>:<></>}
              <th className="py-2 px-2 border-b border-gray-200 text-[white] font-inter text-[11px]">
                STATUS
              </th>
            </tr>
          </thead>
          <tbody className="max-h-[500px] overflow-y-auto">
            {loading ? (
              <tr className=" w-full">
                <td
                  colSpan="12"
                  className="py-2 px-4 text-center text-gray-500 w-[100%]"
                >
                  Loading...
                </td>
              </tr>
            ) :paginatedData.length === 0 ? (
              // When there's no data
              <tr className=" w-full ">
                <td colSpan="12" className="py-2  text-center text-gray-500 ">
                  No Data Available
                </td>
              </tr>
            ) : (
              paginatedData.map((item, index) => (
                <tr key={index} className="text-[#4B5563]">
                  <td
                    onClick={() => handlePatientClick(item)}
                    className="py-2 px-2 cursor-pointer border-b border-gray-200 text-[#4B5563] font-inter text-[12px] "
                  >
                    <span className="hover:underline">
                      {" "}
                      {item.patient_name}
                    </span>
                    <br />({item.patientid})
                  </td>
                  <td className="py-3 px-2 font-inter text-[13px] border-b border-gray-200">
                    {dayjs(item.payment_date).format("MMM D, YYYY h:mm A")}
                  </td>
                  <td className="py-2 px-2 border-b border-gray-200 text-[13px] font-inter">
                    {item.payment_location}
                  </td>
                  <td className="py-2 px-2 border-b border-gray-200 text-[13px] font-inter">
                    {item.copay}
                  </td>
                  <td className="py-2 px-2 border-b border-gray-200 text-[13px] font-inter">
                    {item.selfpay}
                  </td>
                  <td className="py-2 px-2 border-b border-gray-200 text-[13px] font-inter">
                    {item.payment_on_account}
                  </td>
                  <td className="py-2 px-2 border-b border-gray-200 text-[13px] font-inter">
                    ${item.amount}
                  </td>
                  <td className="py-2 px-2 border-b border-gray-200 text-[13px] font-inter">
                     {item.type}{item.ccnumber && item.ccnumber !== "0000" && item.ccnumber !== 0
  ? `- ${item.ccnumber}`
  : ""}
                  </td>
                      {isdeletedRecords?<td className="py-2 px-2 border-b border-gray-200 text-[13px] font-inter">
              {item.createdby}
                  </td>:<></>}
              {slim ? null : item?.delete_request_by?<td className="py-2 px-2 border-b border-gray-200 text-[13px] font-inter">
              {item?.delete_request_reason}-
              {item?.delete_request_by}
                  </td>:<td>-</td>}
                   {!slim&&isRequested&&!isdeletedRecords?<td className="py-2 px-2 border-b border-gray-200 text-[13px] font-inter">
              {item?.delete_request_reason}
                  </td>:<></>}
                   {!slim&&isRequested&&!isdeletedRecords?<td className="py-2 px-2 border-b border-gray-200 text-[13px] font-inter">
              {item?.delete_request_by}
                  </td>:<></>}
                  <td className="py-2 px-2 border-b border-gray-200 flex justify-center items-center gap-2">
                    <button className="rounded-full py-2  text-[12px] w-[100px] border-[1.5px] border-gray-100 font-inter bg-[#E179541A] text-[#E17954] whitespace-nowrap focus:outline-none">
                      {item.status === 2 ? "Athena Posted" : "Self pay"}
                    </button>
            {paymentprev.includes('Edit Payment')&&!isdeletedRecords&& (
  <button  
    onClick={() => {
      setSelectedCard(item);
      setpaymentModal(true);
    }}
    className="focus:outline-none"
  >
    {editIcon}
  </button>
)}

                    <button onClick={() =>fetchpaymenthistory(item||'')} className="focus:outline-none">
                      {historyIcon}
                    </button>
         {slim ? null : paymentprev.includes('Delete Payment') && item?.delete_request_by ? (
  <div
    onClick={() => {
      setDeleteItem(item);
      setDeleteModal(true);
    }}
    className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-[#1D2951] text-[#71717A] hover:text-[#FFF] cursor-pointer"
  >
    {deleteIcon}
  </div>
) : !paymentprev.includes('Delete Payment') && !item?.delete_request_by ? (
  <div
    onClick={() => {
      setRequestItem(item);
      setRequestModal(true);
    }}
    className="cursor-pointer"
  >
    {/* <img src={close} alt="close" /> */}
    <FlagCircleIcon className="text-[#ff0011]"/>
  </div>
) : null}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {/* Pagination + Per Page Dropdown - commented out to show all records
<div className="flex justify-between items-center mt-4">

  <span className="text-sm text-gray-600">
    Showing {startIndex + 1} to {Math.min(endIndex, data.length)} of {data.length} entries
  </span>

  <div className="flex gap-4 items-center">
    {/* Per Page Dropdown }
    <div className="flex items-center gap-2">
      <span className="text-sm">Per page</span>
      <select
        className="border p-1 rounded-md text-sm"
        onChange={(e) => {
          setItemsPerPage(Number(e.target.value));
          setCurrentPage(0); // reset to first page
        }}
        value={itemsPerPage}
      >
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
    </div>

    {/* React Paginate }
    <ReactPaginate
      previousLabel={
        <div className="px-3 py-[6px] border text-sm mr-1 rounded text-black">
          Previous
        </div>
      }
      nextLabel={
        <div className="px-3 py-[6px] border text-sm ml-1 rounded text-black">
          Next
        </div>
      }
      pageCount={Math.ceil(data.length / itemsPerPage)}
      onPageChange={handlePageClick}

      pageRangeDisplayed={1}
      marginPagesDisplayed={0}
      breakLabel={null}
      breakClassName={"hidden"}

      forcePage={currentPage}
      renderOnZeroPageCount={null}

      containerClassName="pagination flex items-center gap-2"
      activeClassName="active-page"
      pageClassName="page-item"
      pageLinkClassName="page-link px-3 py-2 border rounded-md text-black cursor-pointer"
    />

    {/* Pagination CSS }
    <style>{`
      .pagination .page-link {
        background-color: #1D2951 !important;
        border-color: #1D2951 !important;
        color: white !important;
      }
      .pagination .page-link:hover {
        background-color: #32406b !important;
      }
      .pagination .active-page .page-link {
        background-color: #32406b !important;
        border-color: #32406b !important;
        color: #fff !important;
      }
      .pagination .page-item {
        display: none !important;
      }
      .pagination .active-page {
        display: block !important;
      }
      .pagination .break-me {
        display: none !important;
      }
    `}</style>
  </div>
</div>
*/}

      <div className="text-left mt-2 text-[#E17954] font-semibold font-inter">
        Daily Totals
      </div>
      {/* <Reportstotal
        data={data}
        fetchMethdata={fetchMethdata}
        handleCheckLocaClick={handleCheckLocaClick}
        handleCheckMethodClick={handleCheckMethodClick}
      /> */}
      <Reportstotal
  data={totalData}
  handleCheckLocaClick={handleCheckLocaClick}
  handleCheckMethodClick={handleCheckMethodClick}
  checkLoca={checkLoca}
  checkMethod={checkMethod}
  onclearfilters={onclearfilters}
  grandTotalOnly={slim}
/>
<DeleteConfirmModal
  open={deleteModal}
  onClose={() => setDeleteModal(false)}
  onConfirm={confirmDelete}
  loading={loading}
/>
<DeleteRequestModal
  open={requestModal}
  item={requestItem}
  onClose={() => setRequestModal(false)}
  onSubmit={(reason, item) => {
    handlerequest(reason, item);
  }}
/>

      <HistoryModal
      selectedpatient={selectedpatient}
        isOpen={showHistory}
       historyData={historydata}
        onClose={() => setShowHistory(false)}
      />
    </div>
  );
};
 
export default Reporttable;
 
 